import ss from 'simple-ajax-uploader';

function createImgUploader(el) {
	var multiple = el.dataset.multiple == 'true' ? true : false;
	var name = el.dataset.name !== undefined ? el.dataset.name : 'image';
	var target = el.dataset.target !== undefined ? document.getElementById(el.dataset.target) : el.nextSibling;
	var alerts = target.querySelector('.alerts');
	var thumbnails = target.querySelector('.thumbnails');

	var imageuploader = new ss.SimpleUpload({
		button: el,
		url: el.dataset.url,
		name: 'uploadfile',
		multiple: multiple,
		multipleSelect: multiple,
		hoverClass: 'hover',
		focusClass: 'hover',
		progressUrl: el.dataset.progress,
		responseType: 'json',
		accept: 'image/*',
		allowedExtensions: ['jpg', 'jpeg', 'png', 'gif'],
		onChange: function( filename, extension, uploadBtn, fileSize, file ) {
			alerts.querySelectorAll('.alert').forEach(function(alert) {
				alert.remove();
			});
		},
		onSubmit: function(filename, extension, uploadBtn, fileSize) {
			alerts.querySelectorAll('.alert').forEach(function(alert) {
				alert.remove();
			});
			var wrapper = document.createElement('div');
			wrapper.classList.add('progress');
			wrapper.innerHTML = '<div class="progress-bar" role="progressbar"></div>';
			alerts.insertBefore(wrapper, alerts.firstChild);
			this.setProgressContainer(wrapper);
			this.setProgressBar(wrapper.querySelector('.progress-bar'));
			this.setPctBox(wrapper.querySelector('.progress-bar'));
		},
		onExtError: function( filename, extension ) {
			var alert = document.createElement('div');
			alert.classList.add('alert', 'alert-danger');
			alert.innerHTML = 'Type de fichier non autorisé (jpg, jpeg, png, gif)';
			alerts.appendChild(alert);
			return false;
		},
		onSizeError: function( filename, fileSize ) {
			var alert = document.createElement('div');
			alert.classList.add('alert', 'alert-danger');
			alert.innerHTML = 'Le fichier est trop volumineux';
			alerts.appendChild(alert);
			return false;
		},
		onComplete: function(filename, response) {
			if (!response) {
				var alert = document.createElement('div');
				alert.classList.add('alert', 'alert-danger');
				alert.innerHTML = 'Une erreur est survenue lors de l\'upload du fichier';
				alerts.appendChild(alert);
				return false;
			}
			else {
				if (response.success) {
					var div = document.createElement('div');
					div.classList.add('_thumbnail');
					div.innerHTML = '<input type="hidden" name="' + name + '" value="' + response.file + '"><img src="' + response.path + response.file + '" class="img-thumbnail"><button type="button" class="btn-close"></button>';
					if (multiple)
						thumbnails.appendChild(div);
					else
						thumbnails.replaceChildren(div);
					div.querySelector('.btn-close').addEventListener('click', deleteThumbnail);
				}
				else {
					var alert = document.createElement('div');
					alert.classList.add('alert', 'alert-danger');
					alert.innerHTML = 'Une erreur est survenue lors de l\'upload du fichier<br>' + response.msg;
					alerts.appendChild(alert);
					return false;
				}
			}
		}
	});
}


function deleteThumbnail(event) {
	event.preventDefault();
	var parent = event.currentTarget.closest('._thumbnail');
	parent.remove();
}


document.querySelectorAll('._upload_image').forEach(function(item) {
	createImgUploader(item);
});


document.querySelectorAll('._thumbnail').forEach(function(item) {
	item.querySelector('.btn-close').addEventListener('click', deleteThumbnail);
});